import React, {FC, ReactNode} from 'react';

interface PageCtaProps {
  title: ReactNode;
  description?: ReactNode;
  actions: ReactNode;
}

/**
 * 产品页收尾 CTA：与 Home/sections/Cta 同款 aurora-bg 极光背景收尾区，
 * 替换掉此前 3 个产品页里几乎相同的纯文字 CTA 区块。
 * 垂直节奏比首页版本紧凑（py-20 lg:py-28，首页是 py-24 lg:py-32），
 * 因为这是子页面的收尾而不是全站最后一屏的高潮。
 */
const PageCta: FC<PageCtaProps> = ({actions, description, title}) => (
  <section className="relative py-20 lg:py-28 bg-white overflow-hidden">
    <div className="absolute inset-0 aurora-bg">
      <div className="aurora-layer aurora-layer-1" style={{opacity: 0.2}} />
      <div className="aurora-layer aurora-layer-2" style={{opacity: 0.15}} />
    </div>
    <div className="relative z-10 max-w-2xl mx-auto px-6 lg:px-8 text-center">
      <h2 className="font-display font-bold text-3xl lg:text-4xl text-slate-900 tracking-tight mb-5">{title}</h2>
      {description && <p className="text-slate-500 lg:text-lg leading-relaxed mb-9">{description}</p>}
      <div className="flex flex-wrap justify-center gap-4">{actions}</div>
    </div>
  </section>
);

export default PageCta;
